//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    color: var(--light-gray-5);
    line-height: 22px;
    display: flex;
    align-items: center;
    gap: 5px;
    & span {
        font-size: 10px;
    }
`;